module.exports = __webpack_public_path__ + "img/5-1.19be7d1b.svg";